/**
 * Recently-opened clients — a per-device navigational convenience.
 * Pure localStorage; no DB, no migration. Best-effort: never throws into
 * a workbench mount. Descriptive recency only — NOT a ranking or priority.
 */

const STORAGE_KEY = "nexus.recentClients";
const MAX_STORED = 8;

export function getRecentClientIds(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === "string");
  } catch {
    return [];
  }
}

export function recordRecentClient(clientId: string): void {
  if (!clientId) return;
  try {
    const next = [
      clientId,
      ...getRecentClientIds().filter((id) => id !== clientId),
    ].slice(0, MAX_STORED);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable (private mode / quota). Recents are a
    // convenience; swallow so a workbench mount never breaks.
  }
}
